<template>
    <div class="library_search">
        <input type="text" id="search" v-on:keyup.enter="$emit('searchChanged',search)" v-model="search" placeholder="Search...">
        <button @click="$emit('searchChanged',search)">search</button>
    </div>
</template>

<script>
    export default {
       data() {
           return {
               search: '',
           }
       }
    }
</script>